import { OrgFundsRequest } from './types';

const getOrgFundsRequestString = (
  orgFundsRequest: OrgFundsRequest,
  includes?: string
) => {
  const params = new URLSearchParams();

  if (orgFundsRequest?.page) {
    params.set('page', orgFundsRequest.page.toString());
  }
  if (orgFundsRequest?.limit) {
    params.set('limit', orgFundsRequest.limit.toString());
  }
  if (orgFundsRequest?.status) {
    params.set('status', orgFundsRequest.status.toString());
  }
  if (orgFundsRequest.rootIds?.length) {
    orgFundsRequest.rootIds?.forEach(it => {
      params.append('filter[parent_id][]', it);
    });
  }
  if (orgFundsRequest.entityIds?.length) {
    orgFundsRequest.entityIds?.forEach(it => {
      params.append('filter[entity_id][]', it);
    });
  }
  if (orgFundsRequest.reportingPeriodIds?.length) {
    orgFundsRequest.reportingPeriodIds?.forEach(it => {
      params.append('filter[entity.timePeriodId][]', it);
    });
  }
  if (orgFundsRequest.assetManagerIds?.length) {
    orgFundsRequest.assetManagerIds?.forEach(it => {
      params.append('filter[entity.managerOrgId][]', it);
    });
  }
  if (orgFundsRequest.fundIds?.length) {
    orgFundsRequest.fundIds?.forEach(it => {
      params.append('filter[id][]', it);
    });
  }
  if (orgFundsRequest.searchKeyword) {
    params.set('filter[search]', orgFundsRequest.searchKeyword);
  }
  if (orgFundsRequest.excludeSubmissionCancelledFunds) {
    params.set('filter[excludeSubmissionCancelledFunds]', 'true');
  }
  if (includes) {
    params.set('include', includes);
  }
  return params.toString();
};

export const GET_ORGANIZATION_FUNDS = (orgFundsRequest: OrgFundsRequest) => {
  const includes =
    `entity,timePeriod,children,submissionRequest,parent,latestSubmission,` +
    `entity.nature,entity.strategy,entity.assetManager,entity.productType,children.parent,` +
    `children.entity,children.timePeriod,children.latestSubmission,children.submissionRequest,` +
    `children.entity.strategy,children.entity.nature,children.entity.assetManager,children.entity.productType,` +
    `entity.assetManagerUser.user,parent.entity,resourceTags.tag,children.resourceTags.tag`;
  const urlString = getOrgFundsRequestString(orgFundsRequest, includes);
  return (
    `/base/organizations/${orgFundsRequest.orgId}/investments/all-funds?` +
    `${urlString}`
  );
};

export const GET_ORGANIZATION_PENSION_SCHEMES = (
  orgId: string,
  page: number = 1,
  limit: number = 15,
  incompleteFutureReportingPeriod: boolean | null = null
) => {
  let filter = '';
  if (incompleteFutureReportingPeriod) {
    filter = `&filter[incomplete_future_reporting_period]=true`;
  }
  return (
    `/base/organizations/${orgId}/pension-scheme?&page=${page}&limit=${limit}` +
    `&include=entity,timePeriod,managers` +
    `${filter}`
  );
};

export const GET_ORGANIZATION_SUB_FUNDS = (
  orgId: string,
  page: number = 1,
  limit: number = 15,
  status: string | null = null
) => {
  let statusParam = '';
  if (status) {
    statusParam = `&status=${status}`;
  }
  return (
    `/base/organizations/${orgId}/sub-fund?page=${page}&limit=${limit}&include=entity,timePeriod` +
    `${statusParam}`
  );
};

export const POST_SUBMISSION_REQUEST = `/base/submission-requests/send`;

export const POST_ADD_FUND = (orgId: string) => {
  return `/base/organizations/${orgId}/funds`;
};
export const DELETE_SUBMISSION_REQUESTS = `/base/submission-requests/bulk-delete`;

export const PUT_ADD_FUND = (orgId: string, fundId: string) => {
  return `/base/organizations/${orgId}/funds/${fundId}`;
};

export const PUT_ADD_FUND_EXTRAS = (orgId: string, fundId: string) => {
  return `/base/organizations/${orgId}/funds/${fundId}/extras`;
};

export const DELETE_FUND = (
  orgId: string,
  fundId: string,
  investmentId: string,
  parentInvestmentId: string
) => {
  return (
    `/base/organizations/${orgId}/funds/${fundId}?investment_id=${investmentId}&` +
    `parent_investment_id=${parentInvestmentId}`
  );
};

export const POST_ADD_PORTFOLIO = (orgId: string) => {
  return `/base/organizations/${orgId}/portfolios`;
};

export const PUT_ADD_PORTFOLIO = (orgId: string, portfolioId: string) => {
  return `/base/organizations/${orgId}/portfolios/${portfolioId}`;
};

export const DELETE_PORTFOLIO = (
  orgId: string,
  portfolioId: string,
  investmentId: string,
  parentInvestmentId: string
) => {
  return (
    `/base/organizations/${orgId}/portfolios/` +
    `${portfolioId}?investment_id=${investmentId}&parent_investment_id=${parentInvestmentId}`
  );
};

export const GET_STRATEGY = `/base/strategies`;
export const GET_PRODUCT_TYPES = `/base/product-types`;
export const GET_CURRENCY = `/base/currencies`;
export const GET_COST_TEMPLATE = (submissionId: string) => {
  return `/base/submissions/${submissionId}/template`;
};

export const GET_ALL_COST_TEMPLATE = (orgFundsRequest: OrgFundsRequest) => {
  const urlString = `&${getOrgFundsRequestString(orgFundsRequest)}`;
  return (
    `/base/submissions/${orgFundsRequest.orgId}/templates?` + `${urlString}`
  );
};

export const BULK_DOWNLOAD_STATUS = (jobId: string) => {
  return `base/submissions/${jobId}/templates/download`;
};

export const GET_ORGANISATION_MANAGERS = (orgId: string) => {
  return `/base/organizations/${orgId}/providers/managers`;
};
